import i18n from 'i18next';

import { TaskName } from '../enums/TaskName';
import { Task } from '../types/Task';

export const tasks: Record<TaskName, Task> = {
  [TaskName.APPLICANT]: {
    actionTitle: i18n.t('tasks.applicant.actionTitle'),
    description: i18n.t('tasks.applicant.description'),
    destination: null,
    inactive: false,
    setDestination: (pathname: string) => {
      tasks[TaskName.APPLICANT].destination = pathname;
    },
    title: i18n.t('tasks.applicant.title'),
  },
  [TaskName.VERIFICATIONS]: {
    actionTitle: i18n.t('tasks.verifications.actionTitle'),
    description: i18n.t('tasks.verifications.description'),
    destination: '/verifications',
    inactive: false,
    setDestination: (pathname: string) => {
      tasks[TaskName.VERIFICATIONS].destination = pathname;
    },
    title: i18n.t('tasks.verifications.title'),
  },
  [TaskName.COMPLETE]: {
    actionTitle: i18n.t('tasks.complete.actionTitle'),
    description: i18n.t('tasks.complete.description'),
    destination: '/complete',
    inactive: true,
    setDestination: (pathname: string) => {
      tasks[TaskName.COMPLETE].destination = pathname;
    },
    title: i18n.t('tasks.complete.title'),
  },
  [TaskName.CANCELED]: {
    actionTitle: i18n.t('tasks.canceled.actionTitle'),
    description: i18n.t('tasks.canceled.description'),
    destination: '/apply',
    inactive: false,
    setDestination: (pathname: string) => {
      tasks[TaskName.CANCELED].destination = pathname;
    },
    title: i18n.t('tasks.canceled.title'),
  },
  [TaskName.FAILED]: {
    actionTitle: i18n.t('tasks.failed.actionTitle'),
    description: i18n.t('tasks.failed.description'),
    destination: null,
    inactive: false,
    setDestination: (pathname: string) => {
      tasks[TaskName.FAILED].destination = pathname;
    },
    title: i18n.t('tasks.failed.title'),
  },
  [TaskName.QUEUED]: {
    actionTitle: i18n.t('tasks.queued.actionTitle'),
    description: i18n.t('tasks.queued.description'),
    destination: null,
    inactive: false,
    setDestination: (pathname: string) => {
      tasks[TaskName.QUEUED].destination = pathname;
    },
    title: i18n.t('tasks.queued.title'),
  },
};
